<template>
  <c-loading />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CLoading from '@/components/CLoading'

export default {
  name: 'HomeRedirectDetail',
  components: { CLoading },
  computed: {
    ...mapGetters({
      data: 'Home/detailNews'
    })
  },
  created: function () {
    console.log(this.$route.query.id)
    try {
      // URLのクエリをStoreに渡す
      this.action_SelectDetailNews(this.$route.query.id)
    } catch {
      console.log('back します。')
      // this.$router.back(-1)
    }
  },
  mounted: function () {
    document.title = ''
    if (this.data) {
      location.href = this.$route.query.url
    }
  },
  methods: {
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Home', ['action_SelectDetailNews'])
  }
}
</script>

<style scoped>

.l_iframe {
  width: 100%;
  height: 100%;
  border:none;
}

</style>
